import { computeCompletenessOfAttribute } from "./computeCompletenessOfAttribute";
export function computeCompleteness(layout, attributes) {
    // add additional data
    const rows = layout.rows.map((row) => computeCompletenessOfRow(row, attributes));
    return Object.assign(Object.assign({}, layout), { rows });
}
function computeCompletenessOfRow(row, attributes) {
    // add additional data
    const cells = row.cells.map((cell) => computeCompletenessOfCell(cell, attributes));
    const isComplete = cells.every((cell) => cell.isComplete);
    return Object.assign(Object.assign({}, row), { isComplete,
        cells });
}
function computeCompletenessOfCell(cell, attributes) {
    // add additional data
    const rows = !cell.rows
        ? []
        : cell.rows.map((row) => computeCompletenessOfRow(row, attributes));
    // build aggregates
    const cellCompleteness = computeCompletenessOfAttribute(cell, attributes);
    const rowCompleteness = rows.every((row) => row.isComplete);
    const isComplete = cellCompleteness.isComplete && rowCompleteness;
    return Object.assign(Object.assign({}, cell), { isComplete,
        rows });
}
//# sourceMappingURL=computeCompleteness.js.map